import React, { useState } from "react";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import HandleHttpErrors from "../../HandleHttpErrors";
import { useNavigate, useLocation } from "react-router-dom";
const baseURL = process.env.REACT_APP_API_JOBS;

const Edit = ({ depart, handleCancelClick, increment, setDepartId }) => {
  const [depart1, setDepart1] = useState(depart);
  const axiosPrivate = useAxiosPrivate("application/json");
  const navigate = useNavigate();
  const location = useLocation();

  const handleChange = (e) => {
    e.preventDefault(); // prevent the default action
    setDepart1({ id: depart1.id, title: e.target.value }); // set name to e.target.value (event)
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let isMounted = true;
    const controller = new AbortController();
    const getData = async () => {
      try {
        const response = await axiosPrivate.put(
          baseURL + "department/" + depart1.id + "/",
          depart1,
          {
            signal: controller.signal,
          }
        );
        increment();
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          if (err.response.status === 401) {
            navigate("/login", { state: { from: location }, replace: true });
          } else if (err.response.status === 403) {
            alert(HandleHttpErrors(err.response.status));
          }
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          console.log(err);
          alert(" Anything else");
        }
      }
    };
    getData();
    setDepartId(null);
  };
  return (
    <tr>
      <td>{depart.id}</td>
      <td>
        <input
          type="text"
          name="title"
          className="form-control"
          id="title"
          value={depart1.title}
          placeholder="תקליד שם מחלקה להוספה"
          onChange={handleChange}
        />
      </td>
      <td>
        <button
          type="button"
          className="btn btn-secondary"
          onClick={handleSubmit}
        >
          שמירה
        </button>
        <span> </span>
        <button
          type="button"
          className="btn btn-secondary"
          onClick={handleCancelClick}
        >
          ביטול
        </button>
      </td>
    </tr>
  );
};

export default Edit;
